"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _reducers = require('shared/reducers'); var _reducers2 = _interopRequireDefault(_reducers);



const patientResponseRootReducer = _reducers2.default.call(void 0, )

exports. default = patientResponseRootReducer
